export default __webpack_public_path__ + "static/media/bnb.527c3a9f.png";